import { Controller } from "@hotwired/stimulus";
import { buildForm, makeRequest } from "./customization/lib";

// Connects to data-controller="site-builder--navigation"
export default class extends Controller {
  static targets = ["iframe"];

  connect() {
    $(".tooltip").tooltipster({
      maxWidth: 300,
    });
    $(".upload-tooltip").tooltipster({
      maxWidth: 300,
      position: "right",
    });
  }

  mobile() {
    this.iframeTarget.classList.add("phone");
    this.iframeTarget.classList.remove("tablet");
  }

  desktop() {
    this.iframeTarget.classList.remove("phone");
    this.iframeTarget.classList.remove("tablet");
  }

  tablet() {
    this.iframeTarget.classList.remove("phone");
    this.iframeTarget.classList.add("tablet");
  }

  async demo() {
    const formData = buildForm("Schedule a Demo");
    await makeRequest(formData);
    return true;
  }

  async selfSignup() {
    const formData = buildForm("See Pricing");
    await makeRequest(formData);
    return true;
  }
}
